
// JS
import '../../custom/js/index';

// Base SCSS
import '../../custom/scss/base.scss';

import '../../custom/scss/components/error/error.scss';
import '../../custom/scss/components/error/not-found.scss';
